import { render } from "./Quote.vue?vue&type=template&id=52c4f0b9&scoped=true"
import script from "./Quote.vue?vue&type=script&lang=ts"
export * from "./Quote.vue?vue&type=script&lang=ts"

import "./Quote.vue?vue&type=style&index=0&id=52c4f0b9&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-52c4f0b9"

export default script